import { track } from 'ha/modules/Analytics/actions';

export default listings => dispatch => {
  const listingsIds = listings.map(listing => listing.internalID);

  return dispatch(
    track('FacebookAds_Search', {
      content_type: 'home_listing',
      content_ids: listingsIds,
      nonInteraction: 1,
    }),
  );
};
